<template>
<div id="article">
 <div v-if="filteredSutraVersionList.length">
   <nav aria-label="breadcrumb">
     <ol class="breadcrumb">
       <router-link class="breadcrumb-item" to="/avatamsaka/chooseArticle">
        {{$t('avatamsaka.versions.articleRead')}}
       </router-link>
       <li class="breadcrumb-item active" aria-current="page" v-if="filteredSutraList.length">
        《{{$t('avatamsaka.sutras.sutra', {
          'noticeType': $t(`avatamsaka.sutras.sutra0${sutraId}books[${versionId-1}].text`)
        })}}》
       </li>
     </ol>
   </nav>
   <div class="changeTabs">
     <div class="tabs">
       <ul>
         <li>
           {{$t('avatamsaka.articles.read')}}
         </li>
         <li class="uncheckTab">
           <router-link class="breadcrumb-item"
           :to="{path: '/avatamsaka/version/'
           + versionId + '/sutra/' + sutraId + '/articleVocabulary'}">
            {{$t('avatamsaka.articles.contrast')}}
           </router-link>
         </li>
       </ul>
     </div>
   <div class="content">
     <div class="mp3">

       <div class="player">
         <div class="cover">
           <img :src="sutraList[sutraId-1].sutraImg">
         </div>
         <div class="info">

             <vue-audio :file="mp3LinkFile" ref="audioFile"></vue-audio>

         </div>
       </div>
     </div>
     <div class="singleContent" @mousedown="clickArticle()">
       <componentTexts/>
     </div>
   </div>
 </div>
 </div>
 <div class="noThisVer" v-if="noThisVer">
    {{$t('avatamsaka.other.chooseOtherVer')}}
   <ul>
     <li @click="getVersionPath(1)">
       {{$t('avatamsaka.versions.version', {
         'noticeType': $t(`avatamsaka.versions.type[0].text`)
       })}}
     </li>
     <li @click="getVersionPath(2)">
       {{$t('avatamsaka.versions.version', {
         'noticeType': $t(`avatamsaka.versions.type[1].text`)
       })}}
     </li>
     <li @click="getVersionPath(3)">
       {{$t('avatamsaka.versions.version', {
         'noticeType': $t(`avatamsaka.versions.type[2].text`)
       })}}
     </li>
     <li @click="getVersionPath(4)">
       {{$t('avatamsaka.versions.version', {
         'noticeType': $t(`avatamsaka.versions.type[3].text`)
       })}}
     </li>
     <li @click="getVersionPath(5)">
       {{$t('avatamsaka.versions.version', {
         'noticeType': $t(`avatamsaka.versions.type[4].text`)
       })}}
     </li>
   </ul>
 </div>

</div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue';
import Audio from './Audio/VueAudio.vue';
import { mapState, mapMutations } from 'vuex';

export default {
 name: 'version',
 data() {
   return {
     picked: 'words',
     read: 'no',
     noThisVer: false,
     iOSclick: true,
   };
 },
 components: {
   'vue-audio': Audio,
 },
 created () {
  const articlePath = `s${this.sutraId}toArticle.vue`;
  const versionId = this.versionId;
  Vue.component('componentTexts', function (resolve, reject) {
    require([`@/components/texts/v${versionId}${articlePath}`], resolve)
  });
 },
 computed: {
   mp3List() {
     return this.$store.state.mp3List;
   },
   versionId() {
     return this.$route.params.vid;
   },
   versionList() {
     return this.$store.state.versionList;
   },
   sutraList() {
     return this.$store.state.sutraList;
   },
   versions() {
     return this.$store.getters.versions;
   },
   sutraId() {
     return this.$route.params.sid;
   },
   filteredVersionList() {
     let versionList = [...this.versionList];
     const nowVersionId = Number(this.versionId);

     if (nowVersionId !== '') {
       versionList = versionList.filter(item => item.id === nowVersionId);
     }

     return versionList;
   },
   filteredSutraList() {
     let listSutra = [...this.sutraList];
     const nowSutraId = Number(this.sutraId);

     if (nowSutraId !== '') {
       listSutra = listSutra.filter(item => item.sutraId === nowSutraId);
     }
     listSutra = listSutra[0].name;
     const listSutraName = this.$i18n.t(listSutra);
     return listSutraName;
   },
   filteredSutraVersionList() {
     let sutraList = [...this.filteredVersionList];

     if (sutraList.length !== 0) {
       sutraList = this.filteredVersionList[0].contents;
     }

     const nowSutraId = Number(this.sutraId);

     if (nowSutraId !== '') {
       sutraList = sutraList.filter(item => item.sutraId === nowSutraId);
     }

     return sutraList;
   },
   mp3LinkFile() {
     let mp3name = '/static/mp3/v' + this.$route.params.vid +
       's' + this.$route.params.sid + '.mp3';
     return mp3name;
   },
 },
 watch: {
   filteredSutraVersionList: function noVersion() {

     let versionEx = false;
     const versionList = [...this.filteredVersionList];
     const sutraList = [...this.filteredSutraVersionList]

     if (versionList.length !== undefined) {
       if (versionList.length === 0 || sutraList.length === 0) {
         versionEx = true;
       }
     }

     this.noThisVer = versionEx;
   },
 },
 methods: {
   ...mapMutations(['updateTagClick']),
   clickArticle() {
     if (this.iOSclick) {
       this.$refs.audioFile.play();
       this.$refs.audioFile.pause();
       this.iOSclick = false;
     }
   },
   getVersionPath(versionId) {
     this.$router.push({
       name: 'version',
       params: {
         vid: versionId,
       },
     });
   },
 },
 mounted() {
   this.updateTagClick(true);
   this.$store.dispatch('getSutraList');
   this.$store.dispatch('getVersionList');
   this.$store.dispatch('getMp3List');
 },
};
</script>

<style lang="scss" scoped>
#article {
 .icon-stop2{
   background: red;
   border: 15px solid blue;
 }

   .noThisVer {
       padding: 45px;
       font-size: 1.2em;
       ul {
           list-style: none;
           li {
               margin: 10px;
               padding: 5px;
               background: rgb(221, 242, 219);
           }
           li:hover {
               cursor: pointer;
               background: rgb(241, 235, 178);
           }
       }
   }

   button {
       margin: 5px 3px;
   }

   .changeTabs {
     margin: 40px 20px;
     margin-bottom: 0px;
     text-align: left;
     display: flex;
     flex-direction: column;
     .tabs {
       margin: 0px 20px;
       ul {
         list-style: none;
         padding: 0px;
         margin: 0px;
         color: #fff;
         li {
           float: left;
           padding: 5px 10px;
           border: 1px solid black;
           border-bottom: none;
           list-style: none;
           background: #505444;
         }
         .uncheckTab {
           background: rgba(#505444, 0.4);
           border: none;
           border-top: 1px solid #b8bbb4;
           .breadcrumb-item {
             color: #fff;
           }
           @media screen and (max-width: 768px) {
             display: none;
           }
         }
       }
     }
   }

   .content {
       display: flex;
       border: 1px solid black;
       margin: 40px 20px;
       margin-top: 0px;
       min-height: 500px;
       height: 700px;
       flex-direction: column;
       text-align: left;

       .mp3 {
        background: #394433;
        $player-height: 100px;
        $player-width: 100%;
        height: 102px;
        flex: initial;
        padding: 0;
        border-bottom: 1px solid black;
        position: relative;

           h1 {
               font-family: 'Open Sans', sans-serif;
               font-size: 13pt;
               font-weight: 600;
               text-transform: uppercase;
               color: white;
               cursor: default;
           }

           h4 {
               font-family: 'Open Sans', sans-serif;
               font-size: 8pt;
               font-weight: 400;
               cursor: default;
           }

           h2 {
               font-family: 'Open Sans', sans-serif;
               font-size: 13pt;
               font-weight: 300;
               color: white;
               cursor: default;
           }

           @mixin unselectable() {
               -webkit-touch-callout: none;
               -webkit-user-select: none;
               -moz-user-select: none;
               -ms-user-select: none;
               user-select: none;
           }

           .player {
               height: $player-height;
               width: $player-width;
               display: flex;
               background-color: rgb(57, 68, 52);
               position: relative;
               @include unselectable();
               top: 50%;
               left: 50%;
               transform: translate(-50%, -50%);
               -webkit-transform: translate(-50%, -50%);
           }

           .cover {
               flex: init;
               img {
                   height: $player-height;
                   width: $player-height;
               }
           }

           .info {
               flex: 1;
               height: 100%;
               display: flex;
               flex-direction: column;

               .controls {
                   flex: 1;
                   display: flex;
                   color: #ffffff;
                   .button-items {
                       padding: 10px;
                       float: left;
                       align-self: center;
                   }
               }

               .mp3Bar {
                   flex: initial;
                   display: flex;
                   #slider {
                       flex: 1;
                       margin: 10px;
                       height: calc(1em);
                       background: #fff;
                       div {
                           width: 8px;
                           height: calc(1em);
                           background: #e85e33;
                       }
                   }
                   #timer {
                       flex: initial;
                       padding: 20px;
                       color: #494B4E;
                       line-height: 0;
                       font-size: 1em;
                       color: #ffffff;
                       float: right;
                       font-family: Arial, Sans-Serif;
                   }
               }
           }

       }

       .singleContent {
           flex: 1;
           padding: 5px;
           overflow: scroll;
           -webkit-overflow-scrolling : touch;
           border: none;
           height: 100%;
       }

   }

   @media (max-width: 768px) {
     .content {
       height: 80vh;
     }
   }

}

</style>



// WEBPACK FOOTER //
// src/components/Article.vue